import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Alert } from '@/ui';
import { formValueSelector, reduxForm } from 'redux-form';
import { fetchAllEntities } from '../../../actions';
import ActiveStatusModal from '../../../components/ActiveStatusModal/ActiveStatusModal';
import ZuulLoader from '../../../components/ZuulLoader/ZuulLoader';
import api from '../../../services';
import { filterDataBySearchTerm } from '../../../utils/tableFunctions';
import { fetchAllContainers } from '../../Metadata/Containers/actions';
import { fetchAllLayouts } from '../../Metadata/Layouts/actions';
import { getOfferTypes } from '../../Metadata/Offers/actions';
import { fetchAllSites } from '../../Metadata/Sites/actions';
import { fetchAll } from '../../../services/helpers';
import { renderOrphanedOffers } from '../../Offers/OfferTitle/renderConsts';
import {
  createSDTS,
  createSequenceViewApi,
  getSequence,
  getSequencePublished,
  getSequenceView,
  publishSequenceApi,
  publishSequenceByIdApi,
  updateOrphanedOffers,
  updateSDTS,
  updateSelectedElement,
  updateSequenceViewApi,
} from '../actions';
import DnDFlow from './DnDFlow';
import ExitConfirmation from './ExitConfirmation';
import LeftAside from './components/LeftAside';
import RightAside from './components/RightAside';
import SequenceNav from './components/SequenceNav';
import './SequenceDetails.css';
import {
  getSequenceFlowOffersAndEdges,
  handleFlowOffersInit,
  handleOrphanedOffers,
  hasMultipleStartNodes,
  sortOfferSequences,
} from './sequenceUtils';
import validate from './validate';
import { processCustomVariables } from '../../../components/CustomVariables/utils';
import Criteria from '../../../components/Criteria/Criteria';
import { UnifiedFormCriteriaPanel } from '../../../components/Criteria/CriteriaPanel/UnifiedFormCriteriaPanel';
import { buildCriteriaPayload, handleCriteriaInitialize, handleCriteriaSubmit } from '../../../utils/CriteriaHelpers';
import { resolveFeatureFlag } from '../../../utils/resolveFeatureFlag';
import { containerNames, layoutNames, offerTypeNames } from './constants';
import { getPageTitle } from '../../../utils/pageTitles';
import { Helmet } from 'react-helmet-async';

// ZET-4707: gates the unified criteria panel. Toggle lives in the Feature Toggles admin (GET features).
const FEATURE_FLAG = 'USE_SEQUENCE_CRITERIA_CONFIGURATION';

class SequenceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldHideInactiveOffers: true,
      isActive: false,
      leftAside: true,
      rightAside: true,
      confirmedExit: false,
      confirmedExitModalVisible: false,
      useNewCriteria: false,
      sequence: {},
      offerTypeNameSDTSMap: {
        Form: {},
        Banner: {},
        Question: {},
        'Offer Wall': {},
        Iframe: {},
      },
      offersSequences: [],
      publishedSequence: null,
      offers: [],
      searchTerm: '',
      returnUrlOfferSequence: null,
      offerVariationsByPrimaryOfferId: {},
    };
  }

  // Derived values
  get isEditMode() {
    return !!this.props.params?.sequenceId;
  }

  get sequenceId() {
    return this.props.params?.sequenceId ? parseInt(this.props.params.sequenceId) : null;
  }

  toggleAside = (position) => {
    this.setState({ [position]: !this.state[position] });
  };

  onSubmitForm = async (values) => {
    this.setState({ confirmedExit: true });
    const sequenceFlow = this.props.reactFlowInstance.toObject();
    const isSequenceFlowValid = this.validateOffersSequences(sequenceFlow);
    console.log('saved form values: ', values);
    if (values.customVariables) values.customVariables = processCustomVariables(values.customVariables);
    if (!isSequenceFlowValid) return !isSequenceFlowValid;
    if (this.isEditMode && !this.props.newEntityName) {
      return this.updateSequence(values, sequenceFlow);
    } else {
      return this.createSequence(values, sequenceFlow);
    }
  };

  handleOrphanedOfferClick = (event) => {
    event.preventDefault();
    const clickedId = event.target.getAttribute('data-id');

    const clickedOffer = _.find(this.props.orphanedOffers, (offer) => offer.id === clickedId);

    // Uses clickedOffers' x,y negative position (as offset), adds + 250 so you don't get sent to left side of page
    this.props.reactFlowInstance.setTransform({
      x: -clickedOffer.position.x + 250,
      y: -clickedOffer.position.y,
      zoom: 1,
    });
  };

  validateOffersSequences(sequenceFlow) {
    let [, offers] = getSequenceFlowOffersAndEdges(sequenceFlow.elements);
    let updatedOrphanedOffers = [];
    if (offers.length > 1) {
      updatedOrphanedOffers = handleOrphanedOffers(sequenceFlow.elements);
      const hasMoreThanOneOSHead = hasMultipleStartNodes(sequenceFlow.elements);
      this.props.updateOrphanedOffers(updatedOrphanedOffers, hasMoreThanOneOSHead);
    }

    return updatedOrphanedOffers.length === 0;
  }

  handleSDTSSave = (formValues) => {
    return offerTypeNames.map((offerTypeName, i) => {
      const container = formValues[containerNames[i]];
      const layout = formValues[layoutNames[i]];
      const sdts = {
        container: container ? { id: container.id, name: container.name } : null,
        layout: layout ? { id: layout.id, name: layout.name } : null,
        // this.props.offerTypes is a dictionary of objects with keys corresponding with the offerType names
        offerType: this.props.offerTypes[offerTypeName],
      };

      if (this.isEditMode && !this.props.newEntityName) {
        const currentSDTS = this.state.offerTypeNameSDTSMap[offerTypeName];
        if (currentSDTS.id) {
          sdts.id = currentSDTS.id;
        }
        sdts.sequence = { id: this.sequenceId };
      }
      return sdts;
    });
  };

  handleOffersSequencesSave = (formValues, sequenceFlow) => {
    let [, sequenceFlowOffers] = getSequenceFlowOffersAndEdges(sequenceFlow.elements);

    if (sequenceFlowOffers.length > 1) {
      sequenceFlowOffers = sortOfferSequences(sequenceFlowOffers);
    }

    const offersSequences = sequenceFlowOffers.map((flowElement, i) => {
      const offerId = flowElement.id.split('-')[0];
      const offer = _.find(this.state.offers, (offer) => offer.id === parseInt(offerId));
      const offerTypeName = flowElement.offerType
        ? flowElement.offerType.name
        : offer && offer.offerType
        ? offer.offerType.name
        : '';
      const indexOfOfferTypeName = offerTypeNames.indexOf(offerTypeName);

      const offersSequenceContainer = formValues[`${flowElement.id}`]
        ? formValues[`${flowElement.id}`].container
        : null;
      const offersSequenceLayout = formValues[`${flowElement.id}`] ? formValues[`${flowElement.id}`].layout : null;
      const defaultContainer = formValues[containerNames[indexOfOfferTypeName]] || null;
      const defaultLayout = formValues[layoutNames[indexOfOfferTypeName]] || null;
      const container = offersSequenceContainer
        ? { id: offersSequenceContainer.id, name: offersSequenceContainer.name }
        : defaultContainer
        ? { id: defaultContainer.id, name: defaultContainer.name }
        : null;
      const layout = offersSequenceLayout
        ? { id: offersSequenceLayout.id, name: offersSequenceLayout.name }
        : defaultLayout
        ? { id: defaultLayout.id, name: defaultLayout.name }
        : null;
      // const position = flowElement.position;

      if (flowElement.offersSequence && !this.props.newEntityName) {
        // This flowElement already has an offersSequence associated with it, meaning it exists in the DB and wasn't just created by the user
        const offersSequence = flowElement.offersSequence;

        const OSOffer = offersSequence.offer;
        const sequence = offersSequence.sequence;
        const offersSequenceParent = offersSequence.offersSequenceParent;

        offersSequence.orderBy = i + 1;
        offersSequence.container = container;
        offersSequence.layout = layout;
        offersSequence.isContainerOverwritten = !!offersSequenceContainer;
        offersSequence.isLayoutOverwritten = !!offersSequenceLayout;
        // adding Object if it is a Draft. Will remove once we have a better solution for Draft bugs.
        offersSequence.offer = OSOffer
          ? {
              id: OSOffer.id,
              name: OSOffer.name,
              offerType: OSOffer.offerType,
              isActive: OSOffer.isActive,
              advertiser: offersSequence.offer.advertiser,
            }
          : null;
        offersSequence.sequence = sequence
          ? { id: sequence.id }
          : this.state.sequence
          ? { id: this.state.sequence.id }
          : null;
        offersSequence.offersSequenceParent = offersSequenceParent ? { id: offersSequenceParent.id } : null;
        // offersSequence.position = position;
        return flowElement.offersSequence;
      }

      const newOffersSequence = {
        container,
        layout,
        isContainerOverwritten: !!offersSequenceContainer,
        isLayoutOverwritten: !!offersSequenceLayout,
        offer: offer
          ? {
              id: offer.id,
              name: offer.name,
              offerType: offer.offerType,
              isActive: offer.isActive,
              advertiser: offer.advertiser,
            }
          : null,
        orderBy: i + 1,
        status: 1,
        // position
      };
      return newOffersSequence;
    });

    if (this.isEditMode && !this.props.newEntityName && this.state.returnUrlOfferSequence) {
      // If this is an existing sequence, we already have an existing returnURLOffer saved in state, we're going to attach it back into the sequence (we removed it in the initialize step so it didn't display in the react flow)
      offersSequences.push(this.state.returnUrlOfferSequence);
    }

    return offersSequences;
  };

  handleSequenceSave = (formValues) => {
    const saveAsSite = formValues.saveAsSite
      ? { id: formValues.saveAsSite.id, domain: formValues.saveAsSite.domain }
      : null;
    let offerCriteria = handleCriteriaSubmit(formValues, this.props.handlers, 'offerCriteria');
    // Preserve existing criteria ID ONLY when updating (edit mode and not copying)
    if (this.isEditMode && !this.props.newEntityName) {
      const existingCriteriaId = this.state?.sequence?.offerCriteria?.id || this.props.sequenceView?.sequence?.offerCriteria?.id;
      if (existingCriteriaId) {
        offerCriteria.id = existingCriteriaId;
      }
    }
    // ZET-4707: new criteria path — normalize the panel's config and merge cap fields onto offerCriteria.
    let criteriaConfiguration = null;
    if (this.state.useNewCriteria && formValues.criteria) {
      const payload = buildCriteriaPayload(formValues, offerCriteria);
      criteriaConfiguration = payload.criteriaConfiguration;
      offerCriteria = payload.mergedOfferCriteria;
    }
    return {
      createdAt: formValues.createdAt || new Date(),
      endDate: null,
      flex: parseInt(formValues.flex),
      priority: parseInt(formValues.priority),
      isActive: this.props.newEntityName ? false : this.state.isActive,
      isDynamic: false,
      name: this.props.newEntityName ? this.props.newEntityName : formValues.sequenceName,
      returnRedirectDomain: formValues.returnRedirectDomain || null,
      returnVisits: formValues.targetReturningUsers ? parseInt(formValues.returnVisits) : 0,
      sequenceDescription: formValues.sequenceDescription || null,
      site:
        this.props.newEntityName && saveAsSite
          ? saveAsSite
          : { id: formValues.site.id, domain: formValues.site.domain },
      startDate: null,
      status: 1,
      targetReturningUsers: formValues.targetReturningUsers || false,
      customVariables: formValues.customVariables
        ? JSON.stringify(processCustomVariables(formValues.customVariables))
        : null,
      propertySetsIds: formValues?.propertySetsIds || [],
      propertySetsValues: formValues?.propertySetsValues || {},
      offerCriteria,
      criteriaConfiguration,
    };
  };

  attachPositionAndOSParentToSavedOS = (savedOffersSequences, unsavedOS) => {
    return savedOffersSequences.map((offersSequence) => {
      const correspondingUnsavedOS = _.find(unsavedOS, (os) => os.orderBy === offersSequence.orderBy);
      if (offersSequence.id) {
        correspondingUnsavedOS.id = offersSequence.id;
        correspondingUnsavedOS.offersSequenceParent = offersSequence.offersSequenceParent
          ? { id: offersSequence.offersSequenceParent.id }
          : null;
      }
      return correspondingUnsavedOS;
    });
  };

  updateSequence = async (formValues, sequenceFlow) => {
    const sequence = this.handleSequenceSave(formValues);
    sequence.id = this.sequenceId;
    const sequenceDefaultTemplateSettings = this.handleSDTSSave(formValues);
    const offersSequences = this.handleOffersSequencesSave(formValues, sequenceFlow);
    const sequenceView = {
      sequence,
      sequenceDefaultTemplateSettings,
      offersSequences,
    };

    const zuulUser = JSON.parse(localStorage.getItem('userData'));
    const sequenceViewUpdateResponse = await this.props.updateSequenceViewApi(sequenceView);
    if (this.props.saveError) {
      return false;
    }

    sequenceViewUpdateResponse.sequence = sequence;
    sequenceViewUpdateResponse.offersSequences = this.attachPositionAndOSParentToSavedOS(
      sequenceViewUpdateResponse.offersSequences,
      offersSequences
    );
    sequenceViewUpdateResponse.sequenceDefaultTemplateSettings = sequenceDefaultTemplateSettings;
    console.log(sequenceViewUpdateResponse);
    const sequencePublishedJSON = JSON.stringify(sequenceViewUpdateResponse);
    const sequencePublished = {
      createdAt: formValues.createdAt,
      updatedAt: new Date(),
      sequence,
      sequenceDraft: sequencePublishedJSON,
      sequencePublished: sequencePublishedJSON,
      zuulUser,
    };
    await this.props.publishSequenceByIdApi(sequence.id, sequencePublished);

    if (this.props.saveError || this.props.saveWarning) return false;

    this.props.navigate('/campaigns/sequences');
  };

  createSequence = async (formValues, sequenceFlow) => {
    if (this.props.newEntityName) {
      formValues.sequenceDescription = null;
    }
    const sequenceView = {
      sequence: this.handleSequenceSave(formValues),
      sequenceDefaultTemplateSettings: this.handleSDTSSave(formValues),
      offersSequences: this.handleOffersSequencesSave(formValues, sequenceFlow),
    };
    sequenceView.sequence.createdAt = new Date();

    const sequenceViewResponse = await this.props.createSequenceViewApi(sequenceView);
    const seqPublished = {
      createdAt: new Date(),
      updatedAt: new Date(),
      sequencePublished: JSON.stringify(sequenceViewResponse),
      sequence: sequenceViewResponse.sequence,
      zuulUser: JSON.parse(localStorage.getItem('userData')),
    };

    console.log('sequencePublished', seqPublished);
    await this.props.publishSequenceApi(seqPublished);

    if (!this.props.saveError) {
      this.props.navigate('/campaigns/sequences');
    }
    return !this.props.saveError;
  };

  onClickSubmit = (activeStatus) => {
    const { id } = this.props.sequenceView.sequence;

    if (!this.isEditMode) {
      this.setState({
        isActive: activeStatus,
      });
      return;
    }
    let isActive = activeStatus !== undefined ? activeStatus : this.state.sequence.isActive;
    const update = {
      id,
      isActive,
    };

    api.put(`sequences/active/${id}`, update).then((result) => {
      console.log(JSON.stringify(result.data));
      this.setState({
        isActive,
      });
    });
  };

  filterOffersBySearchTerm = (searchTerm, offers) => {
    const throttledSearch = _.throttle(filterDataBySearchTerm, 500);
    const keysToSearchBy = ['id', 'name'];
    let filteredOffers = throttledSearch(searchTerm, keysToSearchBy, offers);
    return filteredOffers;
  };

  renderAppSwitch = () => {
    return (
      <ActiveStatusModal
        framed
        content={this.state.sequence}
        isActive={this.state.isActive}
        modalType={' Sequence'}
        getErrors={this.getErrors}
        onClickSubmit={this.onClickSubmit}
        disabled={!this.isEditMode}
      />
    );
  };

  getErrors = () => {
    const { saveError, saveErrorMessage, saveErrorStatus, submitFailed, invalid, saveWarning, saveWarningMessage } =
      this.props;
    let errors = {
      invalid: submitFailed ? invalid : false,
      saveError: saveError,
      _error:
        saveError || saveErrorStatus === 504
          ? saveErrorMessage
          : submitFailed
          ? 'One or more of the fields you entered are invalid.'
          : null,
      saveWarning: saveWarning,
      _warning: saveWarningMessage,
    };
    return errors;
  };

  setConfirmedExitModalTrue = (e) => {
    e.preventDefault();
    this.setState({ confirmedExitModalVisible: true });
  };

  handleSDTSInit = (sequenceDefaultTemplateSettings) => {
    const sdtsInitObject = {};
    const offerTypeNameSDTSMap = {};

    offerTypeNames.forEach((offerTypeName, i) => {
      const sdts =
        sequenceDefaultTemplateSettings.find((sdts) => {
          return sdts.offerType && sdts.offerType.name === offerTypeName;
        }) || {};
      const layoutFieldName = layoutNames[i];
      const containerFieldName = containerNames[i];
      sdtsInitObject[layoutFieldName] = sdts.layout || null;
      sdtsInitObject[containerFieldName] = sdts.container || null;

      if (this.isEditMode) {
        // sets a hash map in state to keep track of the existing database SDTS entities, using the offerTypeName as the key, and the sdts object as the value.
        offerTypeNameSDTSMap[offerTypeName] = sdts;
      }
    });

    this.setState({
      offerTypeNameSDTSMap,
    });
    return sdtsInitObject;
  };

  initializeSequenceViewData = () => {
    let { sequenceView } = this.props;
    console.log('SEQUENCE VIEW ==>', sequenceView);
    let { sequence, sequenceDefaultTemplateSettings, offersSequencesFullDTO } = sequenceView;
    let offersSequences = offersSequencesFullDTO || [];
    // filter offersSequences that are offer.isPrimaryVariant = false or has an offerBlock
    offersSequences = offersSequences.filter(
      (os) => (os?.offer?.isPrimaryVariant !== false && os?.offerBlock === null) || os?.offer?.offerType?.id === 9 || os?.offer?.offerType?.id === 10
    );

    console.log('sequence ==>', sequence);
    console.log('sequenceDefaultTemplateSettings ==>', sequenceDefaultTemplateSettings);
    console.log('offersSequences ==>', offersSequences);

    const sdts = this.handleSDTSInit(sequenceDefaultTemplateSettings);
    const [offersSequencesSidePanel, reactFlowOffersAndEdges, returnUrlOfferSequence] = handleFlowOffersInit(
      offersSequences,
      false,
      this.state.sequenceOrderBy,
      this.state.offerVariationsByPrimaryOfferId
    );

    const offerCriteria = handleCriteriaInitialize(sequence.offerCriteria, null);

    sequenceView = {
      createdAt: sequence.createdAt || null,
      endDate: null,
      flex: sequence.flex || 1,
      priority: sequence.priority || 1,
      isActive: sequence.isActive || false,
      isDynamic: false,
      sequenceName: sequence.name || '',
      returnRedirectDomain: sequence.returnRedirectDomain || null,
      returnVisits: sequence.returnVisits || 0,
      site: sequence.site || null,
      startDate: null,
      status: sequence.status || 0,
      sequenceDescription: sequence.sequenceDescription || null,
      customVariables: sequence.customVariables ? JSON.parse(sequence.customVariables) : null,
      targetReturningUsers: sequence.targetReturningUsers || false,
      propertySetsIds: sequence.propertySetsIds || [],
      propertySetsValues: sequence.propertySetsValues || {},
      ...sdts,
      ...offersSequencesSidePanel,
      ...offerCriteria,
    };

    // ZET-4707: new criteria path — carry the saved criteriaConfiguration JSON for the unified panel.
    if (this.state.useNewCriteria && sequence?.criteriaConfiguration) {
      sequenceView.criteria = {
        criteriaConfiguration: JSON.stringify({ ...sequence.criteriaConfiguration }),
      };
    }

    console.log('Initial load for SequenceView: ', sequenceView);
    this.props.initialize(sequenceView);

    // const offers = offersSequencesFullDTO.filter((os) => os.offer.offerType.id !== 8 && os.offer.offerType.id !== 6).map((os) => os.offer);
    const offers = _.uniqBy(
      offersSequencesFullDTO
        .filter((os) => os.offer.offerType.id !== 8 && os.offer.offerType.id !== 6)
        .map((os) => os.offer),
      'id'
    );
    this.setState({
      offersSequences: reactFlowOffersAndEdges,
      // This is the initial load of offers on the left aside and needed in order to drag/drop existing offers in the sequence.
      //  eventually we update the left aside with the last "page" of offers in the DB (modulo 100)
      //  and then finally with the remaining offers once they're fetched in the fetchAll method.
      offers,
      returnUrlOfferSequence,
      isActive: sequence.isActive,
      sequence,
      offerCriteriaId: sequence.offerCriteria?.id || null,
    });
  };

  async getInitialOffers() {
    await api
      .get(`offers/table?limit=100&offset=0`)
      .then(async (res) => {
        let offers = res.data.content?.filter((offer) => {
          return offer.offerType?.id !== 8 && offer.offerType?.id !== 6;
        });
        let combinedOffers = offers.sort((a, b) => b.id - a.id);
        if (this.isEditMode) {
          // This ensures that if the user starts dragging/dropping existing offers in the sequence,
          // they will not be lost due to the fact that the offers on the left aside aren't loaded yet.
          // Once the fetchAll is complete, we'll have all the offers.

          let { offersSequencesFullDTO } = this.props.sequenceView;
          let existingOffers = offersSequencesFullDTO
            .filter((os) => os?.offer?.offerType?.id !== 8 && os?.offer?.offerType?.id !== 6)
            .map((os) => {
              if (os.offerBlock !== null) {
                os.offer.offerBlock = os.offerBlock;
              }
              return os.offer;
            });
          const combinedOffersMap = new Map();
          offers.concat(existingOffers).forEach((offer) => {
            combinedOffersMap.set(offer.id, offer);
          });
          combinedOffers = Array.from(combinedOffersMap.values()).sort((a, b) => b.id - a.id);
        }
        this.setState({
          offers: combinedOffers,
          totalPages: res.data.totalPages,
        });
        let remainingOffers = await fetchAll('offers/table');
        remainingOffers = remainingOffers?.filter((offer) => {
          return offer.offerType?.id !== 8 && offer.offerType?.id !== 6;
        });
        this.setState({
          offers: remainingOffers,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async fetchAllOfferVariations() {
    try {
      const response = await api.get('offervariations/all-variations-map');
      const allVariations = response.data || {};

      // Merge with existing variations from sequence
      this.setState(prevState => ({
        offerVariationsByPrimaryOfferId: {
          ...prevState.offerVariationsByPrimaryOfferId,
          ...allVariations
        }
      }));
    } catch (err) {
      console.error('Error fetching all offer variations:', err);
    }
  }

  // Lifecycle Fns
  async componentDidMount() {
    // API headers and authentication are handled by DefaultLayout
    // ZET-4707: resolve the criteria-migration flag before init so the correct panel renders.
    const useNewCriteria = await resolveFeatureFlag(FEATURE_FLAG);

    const { sequenceId } = this.props.params;
    if (sequenceId) {
      const response = await api.get(`offers-sequence/sequences/${sequenceId}/orderBy`);
      const sequenceOrderBy = response.data;
      await this.props.getSequenceView(sequenceId);
      // Fetch all offer variations first so they're available when initializing (this is responsible for the OV indicators on the flow nodes/offers)
      await this.fetchAllOfferVariations();
      let sequencePublishResponse = await this.props.getSequencePublished(sequenceId);

      const state = {};
      if (sequencePublishResponse) {
        state.publishedSequence = sequencePublishResponse;
      }

      if (this.props.offersTableData) {
        state.offers = this.props.offersTableData;
      }

      this.setState({ ...state, sequenceOrderBy, useNewCriteria }, this.initializeSequenceViewData);
    } else {
      const state = {};
      if (this.props.offersTableData) {
        state.offers = this.props.offersTableData;
      }
      // // No entity, initialize create mode
      this.fetchAllOfferVariations();
      this.props.initialize({});
      this.setState({ ...state, useNewCriteria });
    }

    this.getInitialOffers();
    this.props.fetchAllContainers();
    this.props.fetchAllLayouts();
    this.props.fetchAllSites();
    this.props.getOfferTypes();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.offersTableData !== this.props.offersTableData) {
      this.setState({ offers: this.props.offersTableData });
    }
  }

  componentWillUnmount() {
    this.props.updateSelectedElement({});
    this.props.updateOrphanedOffers([], false);
  }

  setPropertySetsIds = (propertySetsIds) => {
    this.props.change('propertySetsIds', propertySetsIds);
  };

  setPropertySetsValues = (propertySetsValues) => {
    this.props.change('propertySetsValues', propertySetsValues);
  };

  render() {
    const { offersTableLoading } = this.props;
    const { orphanedOffers, hasMoreThanOneOSHead, navigate, handleSubmit } = this.props;

    return (
      <div className='sequence-details-container'>
        <ExitConfirmation
          visible={this.state.confirmedExitModalVisible}
          when={!this.state.confirmedExit && !this.state.shouldWarnUser}
          closeModal={() => this.setState({ confirmedExitModalVisible: false })}
          openModal={() => this.setState({ confirmedExitModalVisible: true })}
          navigate={(path) => {
            navigate(path);
          }}
        />
        <form onSubmit={handleSubmit(this.onSubmitForm)} className='sequence-details-content'>
          <Helmet>
            <title>{getPageTitle(location.pathname, this.props.sequenceName)}</title>
          </Helmet>
          <SequenceNav
            setConfirmedExitModalTrue={this.setConfirmedExitModalTrue}
            leftAside={this.state.leftAside}
            toggleAside={this.toggleAside}
            getErrors={this.getErrors}
            onSubmitForm={this.onSubmitForm}
            sequenceName={this.props.sequenceName}
            isActive={this.state.isActive}
            toggle={this.renderAppSwitch()}
            submitting={this.props.submitting}
            sites={this.props.sites}
            rightAside={this.state.rightAside}
            handleSubmit={handleSubmit}
            publishedSequence={this.state.publishedSequence}
          />

          <Grid container className='sequence-main-row'>
            {this.state.leftAside && (
              <Grid
                size={{ xs: 12, md: 2 }}
                className={`toggled-${this.state.leftAside ? 'show' : 'hide'}`}
              >
                <LeftAside
                  isPublished={this.state.isPublished}
                  offers={this.state.offers}
                  areOffersLoading={offersTableLoading || this.state.offers.length === 0}
                />
              </Grid>
            )}
            <Grid id='sequenceDropzone' size={{ xs: 12, md: this.state.leftAside ? 7 : 9 }}>
              {orphanedOffers.length ? (
                <Box sx={{ flexShrink: 0 }}>
                  <Alert id='invalid-offers-alert' color='info'>
                    {hasMoreThanOneOSHead
                      ? 'A break in this sequence is resulting in two or more starting points. '
                      : ''}
                    The following offers are invalid:{' '}
                    {renderOrphanedOffers(orphanedOffers, this.handleOrphanedOfferClick)}
                  </Alert>
                </Box>
              ) : null}
              {this.props.initialized ? (
                <>
                  {/* Bounded + independently scrollable: #sequenceDropzone clips overflow (needed so the
                      DnD canvas below gets a fixed viewport), so the criteria panel needs its own scroll
                      region rather than relying on that clip — otherwise content taller than the column
                      (e.g. the new Caps & Restrictions tab) is cut off with no way to reach it. */}
                  {/* The wrapper owns the border, the radius and the clipping: it is the element
                      that stays put, so the card's own would scroll out of view behind it. */}
                  <Box
                    sx={{
                      flexShrink: 0,
                      maxHeight: '45vh',
                      overflowY: 'auto',
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: 1,
                      mb: 2,
                      '& > .MuiCard-root': { border: 0 },
                    }}
                  >
                    {this.state.useNewCriteria ? (
                      <UnifiedFormCriteriaPanel name='criteria' sourceType='sequence' formType='redux-form' />
                    ) : (
                      <Criteria criteriaType='Sequence' />
                    )}
                  </Box>
                  <Box sx={{ flex: 1, minHeight: 0 }}>
                    <DnDFlow
                      initialElements={this.state.offersSequences}
                      offers={this.state.offers}
                      filteredOffers={this.state.offers}
                      sequenceOrderBy={this.state.sequenceOrderBy}
                      offerVariationsByPrimaryOfferId={this.state.offerVariationsByPrimaryOfferId || {}}
                    />
                  </Box>
                </>
              ) : (
                <ZuulLoader text={'Initializing sequence editor...'} />
              )}
            </Grid>
            {this.state.rightAside && (
              <Grid
                id='sequenceOfferMetadata'
                size={{ xs: 12, md: 3 }}
                className={`toggled-${this.state.rightAside ? 'show' : 'hide'}`}
              >
                <RightAside
                  sites={this.props.sites}
                  isEditMode={this.isEditMode}
                  targetReturningUsers={this.props.targetReturningUsers}
                  layouts={this.props.layouts}
                  containers={this.props.containers}
                  offerTypes={this.props.offerTypes}
                  selectedElement={this.props.selectedElement}
                  propertySetsIds={this.props.propertySetsIds}
                  propertySetsValues={this.props.propertySetsValues}
                  setPropertySetsIds={this.setPropertySetsIds}
                  setPropertySetsValues={this.setPropertySetsValues}
                  offerVariationsByPrimaryOfferId={this.state.offerVariationsByPrimaryOfferId}
                />
              </Grid>
            )}
          </Grid>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    orphanedOffers,
    hasMoreThanOneOSHead,
    sequenceView,
    saveError,
    saveErrorMessage,
    saveErrorStatus,
    saveWarning,
    saveWarningMessage,
    reactFlowInstance,
    selectedElement,
    isSequenceSaved,
  } = state.sequence;
  const { layouts, containers, sites, offerTypes } = state.metadata;
  const { newEntityName } = state.components;
  const selector = formValueSelector('sequenceDetails');
  return {
    orphanedOffers,
    hasMoreThanOneOSHead,
    selector,
    sequenceName: selector(state, 'sequenceName'),
    sequenceView,
    saveError,
    saveErrorMessage,
    saveErrorStatus,
    saveWarning,
    saveWarningMessage,
    isSequenceSaved,
    layouts,
    containers,
    sites,
    offerTypes,
    targetReturningUsers: selector(state, 'targetReturningUsers'),
    newEntityName,
    reactFlowInstance,
    selectedElement,
    propertySetsIds: selector(state, 'propertySetsIds'),
    propertySetsValues: selector(state, 'propertySetsValues'),
  };
}

const form = reduxForm({
  form: 'sequenceDetails',
  validate,
});

export default connect(mapStateToProps, {
  fetchAllEntities,
  createSDTS,
  updateSDTS,
  createSequenceViewApi,
  updateSequenceViewApi,
  publishSequenceApi,
  publishSequenceByIdApi,
  getSequence,
  getSequenceView,
  getSequencePublished,
  fetchAllContainers,
  fetchAllLayouts,
  fetchAllSites,
  getOfferTypes,
  updateSelectedElement,
  updateOrphanedOffers,
})(form(withRouter(SequenceDetails)));
